import { useContext } from 'react';
import type { SessionContext } from '@mervonn/shared-types';
import type { Permissions } from './permissions';
import { AuthContext, type AuthContextValue } from './AuthContext';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>');
  return ctx;
}

/** Inside a guarded route the session is guaranteed present. */
export function useSession(): SessionContext {
  const { session } = useAuth();
  if (!session) throw new Error('useSession used outside an authenticated route');
  return session;
}

export function usePermissions(): Permissions {
  const { permissions } = useAuth();
  if (!permissions) throw new Error('usePermissions used outside an authenticated route');
  return permissions;
}
